import { MS_IN_DAY } from 'shared/constants'

/**
 * The next 00:00 UTC after `now`, in ms: the moment the daily tasks reset
 * and the demo coins get their daily top-up. Local time plays no part.
 */
export const getNextUtcMidnight = (now: number = Date.now()) =>
  (Math.floor(now / MS_IN_DAY) + 1) * MS_IN_DAY

/** Milliseconds left until the next 00:00 UTC; always above zero. */
export const getMsUntilUtcMidnight = (now: number = Date.now()) =>
  getNextUtcMidnight(now) - now
